import "tailwindcss/dist/base.min.css"
